import { useState, useEffect } from 'react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export default function SearchBar({ value, onChange, placeholder = 'Search products...', className = '' }: SearchBarProps) {
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => setLocalValue(value), [value]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
  };
  useEffect(() => {
    const timeout = setTimeout(() => onChange(localValue), 300);
    return () => clearTimeout(timeout);
  }, [localValue, onChange]);
  return (
    <div className={`relative ${className}`}>
      <input type="text" value={localValue} onChange={handleChange} placeholder={placeholder} className="w-full px-4 py-2 border border-gray-300 dark:border-[#333] bg-white dark:bg-dj-dark text-gray-900 dark:text-white rounded focus:outline-none focus:ring-2 focus:ring-primary placeholder-gray-500 dark:placeholder-gray-500" />
      {localValue && <button onClick={() => { setLocalValue(''); onChange(''); }} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-400">✕</button>}
    </div>
  );
}
